// extracted by mini-css-extract-plugin
export var blue = "_32-g";
export var brand = "_32-c";
export var darkGrey = "_32-f";
export var disabled = "_32-6";
export var disabledSubtle = "_32-7";
export var error = "_32-8";
export var green = "_32-h";
export var grey = "_32-e";
export var icon = "_32-0";
export var inherit = "_32-b";
export var lightGrey = "_32-d";
export var orange = "_32-j";
export var pink = "_32-l";
export var primary = "_32-1";
export var purple = "_32-m";
export var quaternary = "_32-4";
export var quinary = "_32-5";
export var red = "_32-k";
export var secondary = "_32-2";
export var success = "_32-a";
export var tertiary = "_32-3";
export var warning = "_32-9";
export var white = "_32-n";
export var yellow = "_32-i";